import $ from 'jquery'
import { openMenu, closeMenu, open_menu_state } from '@/function/function.js';
import draggable from 'vuedraggable';

export default {
    name: 'manage-evolution',
    components: {
        draggable
    },
    props: {
        consultation_id: Number,
        selected_evolution: Object,
        evolution_id_initiale: Number
    },
    data() {
        return {
            vm_state: open_menu_state,
            evolution: {
                evolution_id: 0,
                titre: '',
                sections: []
            },
            consultation_section: '',
            all_checked: false,
            one_is_checked: [],

            required_field_is_empty: false,
            is_error: false,
            error_message: '',
            save_loading: false,
            is_new_section: false,

            is_confirm: false,

            selected_section: {},
            drag: false
        }
    },

    watch: {
        selected_evolution() {
            this.one_is_checked = []
            if (this.selected_evolution.groupe_id == 0) {
                this.evolution = {
                    evolution_id: 0,
                    titre: '',
                    sections: []
                }
            } else {
                this.fillEvolution()
            }
        }
    },

    computed: {
        default_consultation_sections(){
            return this.$store.getters["default_consultation_sections"];
        },

        userCredentials() {
            return this.$store.getters['authInfo'];
        },

        current_consultation_evolution() {
            return this.$store.getters['current_consultation_evolution']
        }
    },

    mounted() {
        this.listeDefaultConsultationSection()

        this.$store.dispatch('getCurrentConsultationEvolution', this.consultation_id)

        const ts = this;
        $(document).bind("click", function(e) {
            const $clicked = $(e.target);
            if (!$clicked.parents().hasClass("drp-container")) {
                if (ts.vm_state != 0) {
                    ts.openMenu(ts.vm_state, 'drp-menu', 'animate-zoomIn', 'animate-zoomOut')
                }
            }
        });
    },

    methods: {
        /**
         * Open Menu Dropdown
         */
        async openMenu(state, selector, show_in, show_out) {
            this.vm_state = openMenu.dropMenu(state, selector, show_in, show_out)
        },

        /**
         * Close Menu Dropdown
         */
        async closeMenu(selector, show_in, show_out) {
            this.vm_state = closeMenu.wrapMenu(selector, show_in, show_out)
        },

        listeDefaultConsultationSection() {
            let data = {
                is_default: 0,
                can_show: 0
            }
            this.$store.dispatch('getDefaultConsultationSections', data)
        },

        fillEvolution() {
            this.one_is_checked = []
            this.evolution.evolution_id = this.selected_evolution.groupe_id
            this.evolution.titre = this.selected_evolution.groupe

            this.default_consultation_sections.forEach((default_section) => {
                this.selected_evolution.sections.forEach(section => {
                    if (default_section.id == section.id) {
                        this.one_is_checked.push(section.id)
                    }
                });
            });
        },

        toutSelectionner() {
            this.clearError()
            let is_checked = $('#slct-all').is(":checked")

            if (is_checked) {
                this.one_is_checked = []

                this.default_consultation_sections.forEach((el) => {
                    this.one_is_checked.push(el.id)
                });
                this.all_checked = true
                
            } else {
                this.one_is_checked = []
                this.all_checked = false
            }
        },

        onOneChange() {
            this.clearError()
            document.getElementById("slct-all").checked = false;
        },

        clearError() {
            this.required_field_is_empty = false
            this.is_error = false
            this.error_message = ""
        },

        toggleForm(section) {
            this.is_new_section = (this.is_new_section)?false:true
            this.consultation_section = ''
            if (section) {
                this.selected_section = section
                this.consultation_section = section.libelle
            } else {
                this.selected_section = {
                    id: 0
                }
            }
        },

        async saveEvolution(selector) {
            this.error_message = ""
            this.is_error = false
            const isValid = await this.$refs.evl_form.validate();

            if (!isValid) {
                return;
            }

            if (this.one_is_checked.length == 0) {
                this.required_field_is_empty = true
                return;
            }

            if (this.evolution.evolution_id == 0) {
                this.is_confirm = true
                
                setTimeout(() => {
                    this.scrollTo()
                }, 500);
                const confirm = document.getElementById(selector);

                if (confirm != null) {
                    if (!confirm.checked) { //  Vérifie si l'utilisateur a confirmé la suppression
                        $('.err-msg').fadeIn(500)
                        return;
                    }
                } else {
                    return;
                }
            }
            

            this.save_loading = true

            this.evolution.sections = [...this.one_is_checked]
            this.evolution.consultation_id = this.consultation_id
            this.evolution.user_id = this.userCredentials.id

            this.$store.dispatch('saveConsultationEvolution', this.evolution).then((response) => {
                if (response.success) {
                    this.successToast('Enregistrement effectué avec succès')
                    this.$emit('emitConsultationSection')

                    this.$emit("emitFicheConsultationSection")

                    this.evolution = {
                        evolution_id: 0,
                        titre: '',
                        sections: []
                    }
                    this.$refs.evl_form.reset()

                    this.$refs.mng_evolution.click()
                } else {
                    this.is_error = true
                    if (response.code === 409) {
                        this.error_message = "Une évolution existe déjà sous le même nom !"
                    } else if (response.code === 500) {
                        this.error_message = "Une erreur s'est produite !"
                    }
                }
                this.save_loading = false
                this.is_confirm = false
            }).catch(() => {
                this.save_loading = false
                this.is_error = true
                this.error_message = "Une erreur s'est produite !"
            })
        },

        async saveSection() {
            const isValid = await this.$refs.section_form.validate();

            if (!isValid) {
                return;
            }

            this.save_loading = true
            const data = {
                user_id: this.userCredentials.id,
                section_id: this.selected_section.id,
                libelle: this.consultation_section
            }
            

            this.$store.dispatch('saveConsultationSection', data).then((response) => {
                if (response.success) {
                    this.listeDefaultConsultationSection()

                    this.is_new_section = (this.is_new_section)?false:true
                    this.$emit("emitConsultationSection")
                } else {
                    this.is_error = true
                    if (response.code === 409) {
                        this.error_message = "Une section existe déjà sous le même nom !"
                    } else if (response.code === 500) {
                        this.error_message = "Une erreur s'est produite !"
                    }
                }
                this.save_loading = false
                
            }).catch(() => {
                this.save_loading = false
                this.is_error = true
                this.error_message = "Une erreur s'est produite !"
            })
        },

        /**
         * Cache le message d'erreur au click du checkbox
         */
        onConfirm() {
            $('.err-msg').fadeOut(500);
        },

        confirmer() {
            this.is_confirm = true
        },

        onChoose: function($event) {
            console.log($event);
        },

        saveOrder() {
            this.selected_evolution.consultation_id = this.consultation_id
            this.selected_evolution.user_id = this.userCredentials.id

            this.save_loading = true
            this.$store.dispatch('saveConsultationSectionOrder', this.selected_evolution).then((response) => {
                if (response.success) {
                    this.$emit('emitConsultationSection')
                    this.$refs.order_evolution.click()
                } else {
                    this.is_error = true
                    if (response.code === 409) {
                        this.error_message = "Une section existe déjà sous le même nom !"
                    } else if (response.code === 500) {
                        this.error_message = "Une erreur s'est produite !"
                    }
                }
                this.save_loading = false
            }).catch(() => {
                this.save_loading = false
                this.is_error = true
                this.error_message = "Une erreur s'est produite !"
            })
        },

        scrollTo() {
            let scroll_value = $('#scrl-target').offset().top
            $('#scrl-anchor').animate({
                scrollTop: scroll_value
            }, 800, function() {});
        },
    }
}